// import { width } from '@mui/system';
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, NavLink, useHistory } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "../Components/Component-css/Header.css";
import css from "./Component-css/Nav.module.css";
import { BsPeople } from "react-icons/bs";
import BottonMenu from "../uiComponents/BottonMenu";
import { BsWallet, BsGift } from "react-icons/bs";
import { IoMdNotificationsOutline } from "react-icons/io";
import { FiPlus } from "react-icons/fi";
import "../Components/Component-css/Header.css";
import { GiHamburgerMenu } from "react-icons/gi";
import { LanguageContext } from "./LanguageContext";
import { useContext } from "react";
import { useTheme } from "../../ThemeContext";
import { apiRequest } from "../../apiService/allApi";
import { FaPlus } from "react-icons/fa";
import { FaUsers } from "react-icons/fa6";

// const w3_close = () => {
//   const width = document.getElementById("mySidebar").offsetWidth;
//   document.getElementById("mySidebar").style.left = `-${width}px`;
//   document.getElementById("sidebarOverlay").style.display = "none";
// };
// const w3_open = () => {
//   document.getElementById("mySidebar").style.left = "0";
//   document.getElementById("sidebarOverlay").style.display = "block";
// };
const w3_close = () => {
  const sidebar = document.getElementById("mySidebar");
  const overlay = document.getElementById("sidebarOverlay");

  // सुनिश्चित करें कि Sidebar मौजूद है
  if (sidebar) {
    // अगर mySidebar मौजूद है, तभी उसकी width पढ़ें
    const width = sidebar.offsetWidth;
    sidebar.style.left = `-${width}px`;
  }

  // सुनिश्चित करें कि Overlay मौजूद है
  if (overlay) {
    overlay.style.display = "none";
  }
};

const w3_open = () => {
  const sidebar = document.getElementById("mySidebar");
  const overlay = document.getElementById("sidebarOverlay");

  // सुनिश्चित करें कि Sidebar और Overlay मौजूद हैं
  if (sidebar) {
    sidebar.style.left = "0";
  }
  if (overlay) {
    overlay.style.display = "block";
  }
};

const addsetting = localStorage.getItem("sitSetting");

const addCaseSetting = JSON.parse(addsetting);
const udata = localStorage.getItem("udata");
const profileData = JSON.parse(udata);

const Header = ({ user }) => {
  // console.log(user)

  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++
  const [isdropdownVisible, setIsdropdownVisible] = useState(false);

  const toggleDiv = () => {
    setIsdropdownVisible(!isdropdownVisible);
  };

  const history = useHistory();

  let access_token = localStorage.getItem("token");
  access_token = localStorage.getItem("token");

  const logout = async () => {
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    // axios
    //   .post(
    //     baseUrl + `logout`,
    //     {
    //       headers: headers,
    //     },

    //     { headers }
    //   )

    const respone = await apiRequest(`logout`, "POST", null, headers);
    // .then((res) => {
    // setUser(res.data)
    localStorage.removeItem("token");
    window.location.reload();
    history.push("/");
    // })
    // .catch((e) => {
    //   if (e.response.status == 401) {
    //     localStorage.removeItem("token");
    //     localStorage.removeItem("token");
    //   }
    // });
  };

  const [promptInstall, setPromptInstall] = useState(null);
  const [supportsPWA, setSupportsPWA] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      console.log("beforeinstallprompt event was fired");
      setPromptInstall(e);
      setSupportsPWA(true);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const onClick = (evt) => {
    evt.preventDefault();
    if (!promptInstall) {
      console.log("No promptInstall event available");
      return;
    }
    promptInstall.prompt();
    promptInstall.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === "accepted") {
        console.log("User accepted the install prompt");
      } else {
        console.log("User dismissed the install prompt");
      }
      setPromptInstall(null);
    });
  };

  // language
  const { changeLanguage } = useContext(LanguageContext);
  const translations = {
    hi: {
      commission: "कमीशन: 5% : रेफरल: सभी खेलों के लिए 3%",
      profile: "मेरी प्रोफाइल",
      play: "खेले",
      wallet: "वॉलेट",
      refer: "रेफरल और कमाएँ",
      history: "इतिहास",
      support: "सहायता",
      // app: "ऐप डाउनलोड",
      redeem: "रेफर रिडीम",
      kyc: "केवाईसी",
    },
    en: {
      commission: "COMMISSION: 5% : REFERRAL: 3% FOR ALL GAMES",
      profile: "My Profile",
      play: "Play",
      wallet: "My Wallet",
      refer: "Refer and Earn",
      history: "History",
      redeem: "Refer Redeem",
      support: "Support",
      // app: " App ",
      kyc: "KYC",
    },
  };

  const { language } = useContext(LanguageContext);

  // change theme
  const { theme, toggleTheme } = useTheme("light");
  const theme1 = localStorage.getItem("theme");

  const styles = {
  backgroundColor: theme1 === "light" ? "#ffffff" : "#000000",
  color: theme1 === "light" ? "#000000" : "#ffffff",
};

const styles1 = {
  backgroundColor: theme1 === "light" ? "#ffffff" : "#6c757d",
  color: theme1 === "light" ? "#000000" : "#ffffff",
};
  const toggleThemeHandler = () => {
  const newTheme = theme1 === "light" ? "dark" : "light";
  localStorage.setItem("theme", newTheme);
  toggleTheme(newTheme);
  };
  const logo =
  theme1 === "light"
    ? "/logo.png"
    : "/logo-white.png";

  useEffect(() => {
  const savedTheme = localStorage.getItem("theme") || "light";
  toggleTheme(savedTheme);
}, []);

  return (
    <>
      <div>
        {/* <div className="header_top_message ">
          <span className="">{translations[language].commission}</span>
        </div> */}
        {access_token ? (
          <React.Fragment>
            <div id="sidebarOverlay" onClick={w3_close}>

            <div className="new_sidebar_main" style={styles}>

              <div
                className="new_sidebar"
                id="mySidebar"
              >

                {/* TOP PROFILE */}

                <div className="sidebar_top_profile">

                  <span
                    className="close_sidebar_btn"
                    onClick={w3_close}
                  >
                    <img src="/images/icons/close.png" alt="" />
                  </span>

                  <Link
                    to={"/landing"}
                    className="profile_top_box"
                    onClick={w3_close}
                  >

                    <div className="profile_img_box">

                      {user && user?.avatar ? (

                        <img
                          src={baseUrl + `${user?.avatar}`}
                          alt="profile"
                          className="profile_user_img"
                        />

                      ) : (

                        <img
                          src="../logo.png"
                          alt="profile"
                          className="profile_user_img"
                        />

                      )}

                    </div>

                    <div className="profile_user_details">

                      <h2>
                        {user?.Name || "Rajwada  User"}
                      </h2>

                      <p>
                        Welcome Back 👋
                      </p>

                    </div>

                  </Link>

                </div>

                {/* MENU ITEMS */}

                <div className="sidebar_menu_main">

                  {/* PLAY */}
                  <Link
                    to={"/Profile"}
                    className="new_sidebar_link"
                    onClick={w3_close}
                  >

                    <div className="sidebar_left_icon">

                      <img
                        alt="img"
                        src="/images/icons/sidebar-user.png"
                      />

                    </div>

                    <h3>
                      {translations[language].profile}
                    </h3>

                    <img
                      className="sidebar_arrow"
                      src="/images/right-arrow.png"
                      alt=""
                    />

                  </Link>

                  <Link
                    to={"/wallet"}
                    className="new_sidebar_link"
                    onClick={w3_close}
                  >

                    <div className="sidebar_left_icon">

                      <img
                        alt="img"
                        src="/images/icons/digital-wallet.png"
                      />

                    </div>

                    <h3>
                      {translations[language].wallet}
                    </h3>

                    <img
                      className="sidebar_arrow"
                      src="/images/right-arrow.png"
                      alt=""
                    />

                  </Link>
                  <Link
                    to={"/Homepage/ludoClassicManual"}
                    className="new_sidebar_link"
                    onClick={w3_close}
                  >

                    <div className="sidebar_left_icon">

                      <img
                        alt="img"
                        src="/images/icons/play-button.png"
                      />

                    </div>

                    <h3>
                      {translations[language].play}
                    </h3>

                    <img
                      className="sidebar_arrow"
                      src="/images/right-arrow.png"
                      alt=""
                    />

                  </Link>

                  {/* REFER */}

                  {addCaseSetting?.isReferral ? (

                    <Link
                      to={"/refer"}
                      className="new_sidebar_link"
                      onClick={w3_close}
                    >

                      <div className="sidebar_left_icon">

                        <img
                          alt="img"
                          src="/images/icons/referrr.png"
                        />

                      </div>

                      <h3>
                        {translations[language].refer}
                      </h3>

                      <img
                        className="sidebar_arrow"
                        src="/images/right-arrow.png"
                        alt=""
                      />

                    </Link>

                  ) : ""}

                  {/* REDEEM */}

                  <Link
                    to={"/redeem/refer"}
                    className="new_sidebar_link"
                    onClick={w3_close}
                  >

                    <div className="sidebar_left_icon">

                      <img
                        alt="img"
                        src="/images/Referral.png"
                      />

                    </div>

                    <h3>
                      {translations[language].redeem}
                    </h3>

                    <img
                      className="sidebar_arrow"
                      src="/images/right-arrow.png"
                      alt=""
                    />

                  </Link>

                  {/* HISTORY */}

                  <Link
                    to={"/history"}
                    className="new_sidebar_link"
                    onClick={w3_close}
                  >

                    <div className="sidebar_left_icon">

                      <img
                        alt="img"
                        src="/images/icons/refresh.png"
                      />

                    </div>

                    <h3>
                      {translations[language].history}
                    </h3>

                    <img
                      className="sidebar_arrow"
                      src="/images/right-arrow.png"
                      alt=""
                    />

                  </Link>

                  {/* LANGUAGE */}

                  <div className="new_sidebar_link">

                    <div className="sidebar_left_icon">

                      <img
                        alt="img"
                        src="../images/icons/translate.png"
                      />

                    </div>

                    <div className="language_toggle_main">

                      <button
                        className={`language_btn ${
                          language === "en" ? "active_lang" : ""
                        }`}
                        onClick={() => changeLanguage("en")}
                      >
                        EN
                      </button>

                      <button
                        className={`language_btn ${
                          language === "hi" ? "active_lang" : ""
                        }`}
                        onClick={() => changeLanguage("hi")}
                      >
                        HI
                      </button>

                    </div>

                  </div>

                  {/* POLICY */}

                  <div
                    className="new_sidebar_link"
                    onClick={toggleDiv}
                  >

                    <div className="sidebar_left_icon">

                      <img
                        alt="img"
                        src="/images/icons/insurance.png"
                      />

                    </div>

                    <h3>
                      All Policy
                    </h3>

                    <img
                      className={`sidebar_arrow ${
                        isdropdownVisible ? "rotate_arrow" : ""
                      }`}
                      src="/images/right-arrow.png"
                      alt=""
                    />

                  </div>

                  {/* DROPDOWN */}

                  {isdropdownVisible && (

                    <div className="policy_dropdown_main">

                      <Link
                        to="/privacy-policy"
                        onClick={w3_close}
                      >
                        Privacy Policy
                      </Link>

                      <Link
                        to="/term-condition"
                        onClick={w3_close}
                      >
                        Terms & Condition
                      </Link>

                      <Link
                        to="/tds-policy"
                        onClick={w3_close}
                      >
                        TDS Policy
                      </Link>

                      <Link
                        to="/responsible-gaming"
                        onClick={w3_close}
                      >
                        Responsible Gaming
                      </Link>

                      <Link
                        to="/about"
                        onClick={w3_close}
                      >
                        About Us
                      </Link>

                      <Link
                        to="/contact-us"
                        onClick={w3_close}
                      >
                        Contact Us
                      </Link>

                    </div>

                  )}

                </div>

              </div>

            </div>
            </div>

            <div className="custom_header_main">

                <div className="header_inner">

                  {/* LEFT MENU */}
                  <div className="header_left">

                    <button
                      className="menu_button_new"
                      onClick={w3_open}
                    >
                      <img
                        src="/images/icons/menu.png"
                        alt="menu"
                      />
                    </button>

                    <Link to="/" className="logo_main">
                      <img
                        src={logo}
                        className="header_logo"
                        alt="logo"
                      />
                    </Link>

                  </div>

                  {/* RIGHT SIDE */}
                  <div className="header_right">

                    {/* WALLET */}
                    <NavLink
                      exact
                      to="/Addcase"
                      className="header_wallet_box"
                    >

                      <img
                        className="wallet_icon"
                        src="/images/Wallet.gif"
                        alt=""
                      />

                      <span>
                        ₹ {user && user?.Wallet_balance}
                      </span>

                    </NavLink>

                    {/* APP DOWNLOAD */}
                    {supportsPWA ? (

                      <div
                        className="header_download_box"
                        onClick={onClick}
                      >

                        <img
                          src="../images/icons/download.png"
                          alt=""
                        />

                      </div>

                    ) : ""}

                    {/* REFER WALLET */}
                    <NavLink
                      exact
                      to="/redeem/refer"
                      className="header_wallet_box refer_wallet_box"
                    >
                      <img
                        className="wallet_icon"
                        src="/images/Referral.png"
                        alt=""
                      />
                      <span>
                        ₹ {user && user.referral_wallet.toFixed(2)}
                      </span>
                    </NavLink>
                  </div>
                </div>
              </div>
          </React.Fragment>
        ) : (
          <div className="w3-teal " style={styles}>
            <div className="w3-container ">
              <div className={`${css.headerContainer} justify-content-between`}>
                <Link to="/">
                  <picture className={`ml-2 ${css.navLogo} d-flex`}>
                    <img
                      src="/logo-white.png"
                      className="snip-img"
                      alt="Rajwada ludo"
                      width="50px" height="40px"
                    />
                  </picture>
                </Link>

                <div className={`ml-5`}>
                  <Link type="button" className="login-btn" to="/login">
                    LOGIN
                  </Link>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="bottom_menus_main">
        <BottonMenu w3_close={w3_close} />
      </div>
    </>
  );
};

export default Header;
